import { defineMessages } from 'react-intl';

export default defineMessages({
    driver: {
        id: 'wni.fnol.pa.directives.contactDetails.Driver',
        defaultMessage: 'Driver'
    },
    person: {
        id: 'wni.fnol.pa.directives.contactDetails.Person',
        defaultMessage: 'Person'
    },
    unknowTips: {
        id: 'wni.fnol.pa.directives.contactDetails.unknowTips',
        defaultMessage: 'If you don\'t know specific {what}, please enter \'Unknown\''
    },
    lastName: {
        id: 'wni.fnol.pa.directives.contactDetails.lastName',
        defaultMessage: 'last name'
    }

});
